import type { MarkType } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';

const AutoColourLinkPlugin = () => {
  return new Plugin({
    appendTransaction: (_transactions, _oldState, newState) => {
      const thisTransaction = newState.tr;
      let modified = false;

      newState.doc.descendants((node, position) => {
        // Find the link mark
        const linkMark = node.marks.find((mark) => mark.type.name === 'link');

        // Find the colour mark and get the colour attribute
        const colorMark = node.marks.find((mark) => mark.attrs.color);

        // We're only interested in text nodes with a link and colour marks
        if (
          node.type.name !== 'text' ||
          node.marks.length === 0 ||
          !linkMark ||
          !colorMark
        )
          return;

        // Get the link mark type from the schema
        const linkMarkType: MarkType = newState.schema.marks.link;

        // The link mark can't be straightforwardly updated,
        // so remove the old link mark
        thisTransaction.removeMark(
          position,
          position + node.nodeSize,
          linkMarkType,
        );

        // Then add a new link mark with the colour
        thisTransaction.addMark(
          position,
          position + node.nodeSize,
          linkMarkType.create({
            ...linkMark.attrs,
            color: colorMark.attrs.color,
          }),
        );

        modified = true;
      });

      return modified ? thisTransaction : null;
    },
  });
};

export { AutoColourLinkPlugin };
